module.exports = __webpack_public_path__ + "static/beds-4-u-931d0d22b129126cca350b6643de7cd1.jpg";